import React from 'react'
import { Card, Button } from 'react-bootstrap'
import { format } from 'date-fns'

const AdverseEventCard = (props) => {
  const { adverseEvent } = props

  const createdDate = adverseEvent?.created_date ? format(new Date(adverseEvent.created_date), "MMMM d,  yyyy") : 'N/A'

  return (
    <Card className='AdverseEventCard'>
      <Card.Body>
        <Card.Title>
          {adverseEvent?.name || 'N/A'}
        </Card.Title>

        <br />

        <Card.Text>
          <span className='chart-card-header'>Site:</span> {' '}
          {adverseEvent?.site?.number && adverseEvent?.site?.name ?
            `${adverseEvent.site.number} - ${adverseEvent.site?.name}` :
            'N/A'
          }
        </Card.Text>

        <Card.Text>
          <span className='chart-card-header'>Patient ID:</span> {' '}
          {adverseEvent?.patient_chart?.patient_identifier || 'N/A'}
        </Card.Text>

        <Card.Subtitle className="subtitle">
          Reported on: {createdDate}
        </Card.Subtitle>

        <br/>

        <center>
          <Button onClick={props.handleClick}>
            View
          </Button>
        </center>
      </Card.Body>
    </Card>
  )
}

export default AdverseEventCard
